import { NIcon } from '@innersource-nn/novoui-react';
import { IconSize } from '@innersource-nn/novoui-react/dist/external-lib/NIcon/NIconSize';
import React from 'react';
type FormSnackBarProps = {
    title: string;
    iconSize: IconSize;
};

export default function FormSnackBar({ title, iconSize }: FormSnackBarProps) {
    return (
        <div className="bg-lava-red-200 w-full text-true-blue p-12 rounded-xl flex gap-16 mt-16 items-center">
            <NIcon
                iconName="alert"
                size={iconSize}
                className="fill-true-blue"
            />
            {title}
        </div>
    );
}
